import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(startPollingNextSessionSaga),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(stopPollingNextSessionSaga),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(loadTutoringSchedulerLaunchInfoSaga),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(tutoringSagas);

import { delay, call, put, takeLatest } from 'redux-saga/effects';
import { getNextTutoringSessionTime, loadTutoringSchedulerLaunchInfo } from '../tutoring-service';
import { LOAD_TUTORING_SCHEDULER_LAUNCH_INFO, START_POLLING_NEXT_TUTORING_SESSION, STOP_POLLING_NEXT_TUTORING_SESSION, tutoringActions } from './tutoring-reducer';

// check every 10 mins to see if there is a new session
var SESSION_POLLING_INTERVAL_MS = 10 * 60 * 1000;
var fetchNextSessionFlag = false;
function startPollingNextSessionSaga() {
  var data, startTime;
  return _regeneratorRuntime.wrap(function startPollingNextSessionSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!fetchNextSessionFlag) {
            _context.next = 2;
            break;
          }

          return _context.abrupt('return');

        case 2:
          fetchNextSessionFlag = true;

        case 3:
          if (!fetchNextSessionFlag) {
            _context.next = 15;
            break;
          }

          _context.next = 6;
          return call(getNextTutoringSessionTime);

        case 6:
          data = _context.sent;
          startTime = void 0;

          if (data.unifiedTutoringNextSessionForStudent) {
            startTime = data.unifiedTutoringNextSessionForStudent.startTime;
          }
          _context.next = 11;
          return put(tutoringActions.setNextTutoringSessionTime(startTime));

        case 11:
          _context.next = 13;
          return delay(SESSION_POLLING_INTERVAL_MS);

        case 13:
          _context.next = 3;
          break;

        case 15:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function stopPollingNextSessionSaga() {
  return _regeneratorRuntime.wrap(function stopPollingNextSessionSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fetchNextSessionFlag = false;

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function loadTutoringSchedulerLaunchInfoSaga() {
  var data;
  return _regeneratorRuntime.wrap(function loadTutoringSchedulerLaunchInfoSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return call(loadTutoringSchedulerLaunchInfo);

        case 2:
          data = _context3.sent;
          _context3.next = 5;
          return put(tutoringActions.setTutoringSchedulerLaunchInfo(data.unifiedTutoringSchedule));

        case 5:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

export function tutoringSagas() {
  return _regeneratorRuntime.wrap(function tutoringSagas$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return takeLatest(START_POLLING_NEXT_TUTORING_SESSION, startPollingNextSessionSaga);

        case 2:
          _context4.next = 4;
          return takeLatest(STOP_POLLING_NEXT_TUTORING_SESSION, stopPollingNextSessionSaga);

        case 4:
          _context4.next = 6;
          return takeLatest(LOAD_TUTORING_SCHEDULER_LAUNCH_INFO, loadTutoringSchedulerLaunchInfoSaga);

        case 6:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}